/* The new header search's switch for searching without the shopper's machine: off for that machine, for the session. */
(function () {
  'use strict';

  if (theme.searchMachineSwitch) return;

  const STORAGE_KEY = 'rpm_search_machine_off';
  // The new search's class (theme.js SEARCH_V2_CLASS): the original search, which can't switch the machine back on, ignores the switch.
  const SEARCH_V2_CLASS = 'search-v2';
  // The fitment app's event for a machine picked anywhere on the site (machine-selector.js; the machine sheet raises it too).
  const MACHINE_SELECTED_EVENT = 'rpm:machine:selected';
  // Kept in memory as well, so the switch holds for the page where storage is unavailable.
  let offId = read();

  // A different machine picked is one to shop for; the app re-announces the same machine on every page, which leaves it off.
  document.addEventListener(MACHINE_SELECTED_EVENT, (event) => {
    const detail = event && event.detail;
    const id = detail && typeof detail.metaobjectId === 'string' ? detail.metaobjectId.trim() : '';
    if (id && offId && id !== offId) set(null);
  });

  function isOff(machine) {
    if (!document.documentElement.classList.contains(SEARCH_V2_CLASS)) return false;
    return !!(machine && machine.id && machine.id === offId);
  }

  // Off for the given machine, or back on with none.
  function set(machine) {
    offId = machine && machine.id ? machine.id : '';
    try {
      if (offId) sessionStorage.setItem(STORAGE_KEY, offId);
      else sessionStorage.removeItem(STORAGE_KEY);
    } catch (e) { /* private browsing: off for this page only */ }
  }

  // A machine picked in the machine sheet, even the one switched off, is one to shop for again. The app reads its handler when a
  // garage row or a new machine is picked (rpm-dropdown-garage.js _selectVehicle), so it's wrapped before any pick.
  function followPicks(dropdown) {
    const select = dropdown.options && dropdown.options.onSelect;
    if (!select) return;
    dropdown.options.onSelect = (machine) => {
      set(null);
      select(machine);
    };
  }

  function read() {
    try { return sessionStorage.getItem(STORAGE_KEY) || ''; } catch (e) { return ''; }
  }

  theme.searchMachineSwitch = { isOff, set, followPicks };
})();
